import React from 'react';

import AccountUserDetailGradeInfo, { useUserGradeInfoViewModel } from './AccountUserDetailGradeInfo';
import AccountUserDetailHistory, { useUserGradeHistoriesViewModel } from './AccountUserDetailHistory';

interface IAccountUserDetailGradeProps {
  userId: number;
  isActive: boolean;
}

const AccountUserDetailGrade = (props: IAccountUserDetailGradeProps): JSX.Element => {
  const { userId, isActive } = props;
  const userGradeInfoViewModel = useUserGradeInfoViewModel(userId, isActive);
  const userGradeHistoriesViewModel = useUserGradeHistoriesViewModel(userId, isActive);

  return (
    <div className="account-user-detail-content">
      <AccountUserDetailGradeInfo {...userGradeInfoViewModel} />
      <AccountUserDetailHistory {...userGradeHistoriesViewModel} />
    </div>
  );
};

export default AccountUserDetailGrade;
